import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

import {forkJoin} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';

import {EmployeeInfo, TreeRootResponse} from '../../../+organizations/org-interfaces';
import {OrgTreeService} from '../../../+organizations/org-tree.service';
import {Destroyable} from '../../../destroyable.component';
import {EntityDTO} from '../../../shared/api/GaApi';

@Component({
  selector: 'gp-delete-entity-modal',
  templateUrl: './delete-entity-modal.component.html',
  styleUrls: ['./delete-entity-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteEntityModalComponent extends Destroyable implements OnInit {
  public employeesList: EmployeeInfo[];
  public entityDTOList: EntityDTO[];
  public trees: TreeRootResponse[];
  public openEmployeeDetail: (contractId: number) => void;
  public openEntityDetail: (isPositionsTree: boolean, treeId: number, entityId: number) => void;
  private orgTreeType = 'organization';
  private peopleTreeType = 'people';
  private positionsTreeName = 'Positions';
  private hierarchicalOrganizationTreeName = 'HierarchicalOrganization';

  constructor(private orgTreeService: OrgTreeService) {
    super();
  }

  public ngOnInit(): void {
    if (!this.isEmployeeReferencingAlert()) {
      forkJoin({
        orgTree: this.orgTreeService.getTreeRoots(this.orgTreeType),
        peopleTree: this.orgTreeService.getTreeRoots(this.peopleTreeType),
      })
        .pipe(
          tap(({orgTree, peopleTree}) => {
            this.trees = [...orgTree, ...peopleTree];
          }),
          takeUntil(this.componentDestroyed$)
        )
        .subscribe();
    }
  }

  public openEmployeeDetailCall(contractId: number) {
    this.openEmployeeDetail(contractId);
  }

  public openEntityDetailCall(entity: EntityDTO): void {
    const isPositionsTree = entity.tree === this.positionsTreeName || entity.tree === this.hierarchicalOrganizationTreeName;

    const treeId = this.trees?.find(tree =>
      tree.name === entity.tree ||
      (tree.name === this.hierarchicalOrganizationTreeName && entity.tree === this.positionsTreeName)
    )?.id;

    this.openEntityDetail(isPositionsTree, treeId, entity.id);
  }

  public isEmployeeReferencingAlert(): boolean {
    return this.employeesList && this.employeesList.length > 0;
  }

  public trackByEmployeeId(_, employee: EmployeeInfo) {
    return employee.id;
  }

  public trackByEntityId(_, entity: EntityDTO) {
    return entity.id;
  }
}
